import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const SpecialSession = () => {
  return (
    <React.Fragment>
      <SEO title="Special Sessions | ICSI 2025" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Special Sessions"
        content="For Authors"
        contentTwo="Special Sessions"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">

          <h3 id="session1">
            Special Session 1: &quot;Machine Learning and Swarm Intelligence for Combinatorial Optimization Problem&quot;{" "}
            <p align="center">&nbsp;</p>
          </h3>


          <p>
            Addressing highly complex combinatorial optimization problems with multiple objectives and various real-world constraints, which are intractable to exact methods, presents to be one of current research challenges in evolutionary computation. With the rapid development of computation power and artificial intelligence, machine learning and swarm intelligence have become promising tools. Machine learning algorithms, such as the reinforcement learning algorithms, have shown strong ability in interactive learning environment. Swarm intelligence algorithms, inspired by the behavior in self-organized groups, such as birds, ants, bacteria, etc., hold the superiority in solving complex optimization problems. How to utilize swarm intelligence algorithms and machine learning algorithms to deal with combinatorial optimization problem remains to be an interesting topic and has attracted attentions from both researchers and engineers.
            <br></br>
            <br></br>
            The objective of this special session is to gather recent theoretical contributions in machine learning and swarm intelligence fields. And it also collects unpublished methods for practical combinatorial optimization problems.

            <br></br>
            {" "}
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li>Theoretical contributions in machine learning algorithms: reinforcement learning, deep learning, machine learning, meta-learning, etc; </li>
              <li>Unpublished ideas in swarm intelligence algorithms: particle swarm optimization, bacterial foraging optimization, genetic algorithm, hydrological cycle optimization, grey wolf optimization, artificial fish search algorithm, etc; </li>
              <li>Efficient methods for combinatorial optimization problems such as vehicle routing problem, nurse scheduling, etc; </li>
              <li>Original work towards multi-objective problems, multi-task problems and constrained problems; </li>
              <li>Other Intelligent Computing and Swarm Intelligence Related Algorithms and Applications.</li>
            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2025 instruction for authors and submit your
            paper via the ICSI 2025 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS1 &quot;
            </strong>{" "} Machine Learning and Swarm Intelligence for Combinatorial Optimization Problem
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Ben Niu</td>
                <td>Shenzhen University</td>
                <td>drniuben@gmail.com</td>
              </tr>
              <tr>
                <td>Wenjie Yi</td>
                <td>Shenzhen University</td>
                <td>wenjie.yi@szu.edu.cn</td>
              </tr>

            </table>
          </p>

          <p>

            Ben Niu (Member, IEEE) received the Ph.D. degree from Shenyang Institute of Automation, Chinese Academy of Sciences, Shenyang, China, in 2008. He is currently a Full Professor with Shenzhen University, China. His research interests include swarm intelligence, operations research and optimization, big data analysis, and medical artificial intelligence. He is an Associate Editor of IEEE Transactions on Artificial Intelligence and IETI Transactions on Data Analysis and Forecasting.
            <br></br>
            <br></br>
            Wenjie Yi received the Ph.D. degree from Computer Science, University of Nottingham, United Kingdom, in 2023. She is currently an Assistant Professor with Shenzhen University, China. Her research interests include automated algorithm design, swarm intelligence and reinforcement learning method.

          </p>

          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br>












          <h3 id="session2">
            Special Session 2: &quot;Large Language Model-Based Swarm Intelligence Optimization Methods&quot;{" "}
            <p align="center">&nbsp;</p>
          </h3>
          <p>
            The integration of large language models (LLMs) with swarm intelligence optimization methods represents a cutting-edge frontier in computational intelligence. As LLMs continue to demonstrate remarkable capabilities in natural language processing, understanding, and generation, their potential to enhance and innovate swarm intelligence algorithms is increasingly evident. This special session aims to explore the synergy between LLMs and swarm intelligence, focusing on how these advanced models can be leveraged to solve complex optimization problems that are otherwise intractable with traditional methods. The session will gather recent theoretical advancements and practical applications, providing a platform for researchers and engineers to share their insights and innovations.
            {" "}
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li>Theoretical contributions in large language models: transformer architectures, pre-training strategies, fine-tuning techniques, and their integration with swarm intelligence algorithms;</li>
              <li>Novel approaches in swarm intelligence algorithms enhanced by LLMs: Fireworks algorithms, particle swarm optimization, ant colony optimization, genetic algorithms, and other bio-inspired optimization techniques;</li>
              <li>Efficient methods for combinatorial optimization problems such as resource allocation, scheduling, and routing, utilizing LLM-based swarm intelligence;</li>
              <li>Original work towards multi-objective optimization, dynamic environments, and constrained optimization problems using LLM-guided swarm intelligence;</li>
              <li>Applications of LLM-based swarm intelligence in real-world scenarios: healthcare, logistics, finance, and other domains;</li>
              <li>Other intelligent computing and swarm intelligence-related algorithms and applications that leverage the power of large language models.</li>
            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2025 instruction for authors and submit your
            paper via the ICSI 2025 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS2 &quot; -- Large Language Model-Based Swarm Intelligence Optimization Methods
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Ying Tan</td>
                <td>Peking Univeresity</td>
                <td>ytan@pku.edu.cn</td>
              </tr>
              <tr>
                <td>Yifan Liu</td>
                <td>Peking Univeresity</td>
                <td>liuyifanpku731@gmail.com</td>
              </tr>

            </table>
          </p>



          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br>



          <h3 id="session3">
            Special Session 3: &quot;Medical Applications Leveraging Machine Learning in the New Era of Knowledge&quot;{" "}
            <p align="center">&nbsp;</p>
          </h3>
          <p>
            In recent years, machine learning has emerged as a transformative force across a wide range of sectors, and its potential in medical applications is particularly significant. As we enter the new era of knowledge, the integration of advanced machine learning techniques into healthcare has the potential to revolutionize diagnostics, treatment protocols, drug discovery, and personalized medicine. This special session aims to explore cutting-edge research on the application of machine learning in the medical field, addressing the most pressing challenges and innovative solutions that contribute to the evolution of healthcare systems globally.
            This session seeks to bring together researchers, professionals, and experts to present their latest findings, discuss key trends, and highlight the ways in which machine learning can enhance medical outcomes, improve patient care, and foster the development of new therapeutic techniques. Topics of interest include the use of machine learning in predictive analytics, medical imaging, disease diagnosis, treatment recommendation systems, as well as healthcare data management. The session will also explore the intersection of AI technologies and medical ethics, ensuring that innovations respect patient privacy and promote equitable access to care.

            {" "}
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li>Machine learning for disease diagnosis and prediction;</li>
              <li>AI applications in personalized medicine;</li>
              <li>Medical imaging and computer vision in healthcare;</li>
              <li>Predictive analytics in healthcare management;</li>
              <li>AI-driven drug discovery and development;</li>
              <li>Machine learning in healthcare data analysis and management;</li>
              <li>Integration of machine learning with telemedicine and digital health platforms;</li>
              <li>Ethical considerations in AI and machine learning in healthcare;</li>
              <li>Healthcare AI and patient privacy issues;</li>
              <li>Human-centered design in AI healthcare applications.</li>
            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2025 instruction for authors and submit your
            paper via the ICSI 2025 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS3 &quot; -- Medical Applications Leveraging Machine Learning in the New Era of Knowledge
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Paola Patricia Ariza Colpas</td>
                <td>Universidad de la Costa</td>
                <td>pariza1@cuc.edu.co</td>
              </tr>
              <tr>
                <td>Marlon Alberto Piñeres Melo</td>
                <td>Universidad del Norte</td>
                <td>pineresm@uninorte.edu.co</td>
              </tr>
              <tr>
                <td>Elizabeth Restrepo Parra</td>
                <td>Universidad Nacional de Colombia</td>
                <td>erestrepopa@unal.edu.co</td>
              </tr>
              <tr>
                <td>Miguel Alberto Urina Triana</td>
                <td>Universidad Simón Bolívar</td>
                <td>miguel.urina@unisimon.edu.co</td>
              </tr>
              <tr>
                <td>Ernesto Barceló Martínez</td>
                <td>Instituto Colombiano de Neuropedagogía</td>
                <td>ebarcelo@icnweb.org</td>
              </tr>
            </table>
          </p>



          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br>








          <h3 id="session4">
            Special Session 4: &quot;Intelligent Computing and Swarm Intelligence in Smart Finance: Theories, Methods, and Practices &quot;{" "}
            <p align="center">&nbsp;</p>
          </h3>
          <p>
            Intelligent Computing and Swarm Intelligence have emerged as powerful paradigms for addressing complex challenges in the financial sector. This special session focuses on the intersection of these computational approaches with Smart Finance, creating a unique platform for researchers and practitioners to explore innovative solutions for financial markets and services.
            <br></br>
            The rapid digitalization of financial systems has generated unprecedented volumes of data and introduced complex decision-making scenarios that traditional methods struggle to handle effectively. Swarm Intelligence techniques—inspired by the collective behaviors of social organisms—offer robust frameworks for optimization, prediction, and risk management in financial contexts. Similarly, Intelligent Computing approaches provide sophisticated tools for data analysis, pattern recognition, and autonomous decision-making in dynamic financial environments.
            <br></br>
            This special session aims to bridge theoretical advancements with practical applications, exploring how these computational paradigms can enhance financial stability, improve investment strategies, optimize portfolio management, detect fraudulent activities, and facilitate regulatory compliance. We welcome contributions addressing theoretical foundations, methodological innovations, and empirical studies that demonstrate the potential of Intelligent Computing and Swarm Intelligence in revolutionizing Smart Finance across various domains and scales.


            {" "}
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li>Swarm intelligence algorithms for financial market prediction </li>
              <li>Bio-inspired computing for fraud detection in financial transactions </li>
              <li>Multi-agent systems for algorithmic trading strategies </li>
              <li>Deep learning applications in smart finance </li>
              <li>Blockchain technology empowered by swarm intelligence</li>
            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2025 instruction for authors and submit your
            paper via the ICSI 2025 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS4 &quot; -- Intelligent Computing and Swarm Intelligence in Smart Finance: Theories, Methods, and Practices
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Hao Tian</td>
                <td>Hubei University of Economics</td>
                <td>th@hbue.edu.cn</td>
              </tr>
              <tr>
                <td>Yi Di</td>
                <td>Hubei University of Economics</td>
                <td>diyi8710@hbue.edu.cn</td>
              </tr>
              <tr>
                <td>Binghua Shi</td>
                <td>Hubei University of Economics</td>
                <td>shibinghua@hbue.edu.cn</td>
              </tr>
              <tr>
                <td>Ling Zheng</td>
                <td>Hubei University of Economics</td>
                <td>lingzheng@hbue.edu.cn</td>
              </tr>
              <tr>
                <td>Jia Guo</td>
                <td>Hubei University of Economics</td>
                <td>guojia@hbue.edu.cn</td>
              </tr>
            </table>
          </p>




          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br>



          {/* <h3 id="session3"> 
            Special Session 3: &quot;Research on Swarm Intelligence Optimization Algorithm Based on Large Language Model&quot;{" "}
            <p align="center">&nbsp;</p>
          </h3>
          <p>
            Large Language Models (LLMs) represent a significant leap in AI, capable of understanding context, generating coherent text, and performing various language tasks with impressive accuracy. These models have been trained on extensive datasets and can mimic human-like language understanding and generation. Despite their advanced capabilities, LLMs face challenges in areas like computational efficiency, adaptability to new and evolving data, and depth of context understanding. <br></br>

            Swarm Intelligence Optimization Algorithms, drawing inspiration from natural phenomena such as the collective behavior of bird flocks or ant colonies, offer a unique approach to problem-solving. Algorithms like Particle Swarm Optimization (PSO) and Fireworks Algorithm (FWA) exemplify this approach, known for efficiently navigating complex, multi-dimensional search spaces. These algorithms excel in optimizing non-linear and intricate functions, which is instrumental in enhancing decision-making and problem-solving aspects of various computational tasks.
            <br></br>
            In this special session, we will explore how the advanced data processing and pattern recognition capabilities of LLMs can contribute to the evolution of swarm intelligence algorithms. Discussions will revolve around novel approaches for applying LLMs to improve the design, implementation, and effectiveness of swarm intelligence methods. Topics will include leveraging LLMs for better algorithmic strategies, enhancing decision-making processes in swarm algorithms, and exploring the adaptability and scalability of these algorithms in diverse applications.
            <br></br>

            By bridging the gap between LLMs and swarm intelligence, this session aims to foster innovative research and collaboration, paving the way for significant advancements in both fields. We anticipate that this interdisciplinary approach will not only enhance our understanding of swarm intelligence algorithms but also expand the potential applications of LLMs in various AI-driven solutions.

            {" "}
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li> <b>Enhancing Swarm Intelligence Algorithms with LLMs</b>: Exploring how large language models can contribute to the design and refinement of swarm intelligence algorithms.</li>
              <li> <b>Data Processing and Analysis in Swarm Intelligence</b>: Leveraging LLMs for advanced data processing, pattern recognition, and analysis in swarm intelligence systems.</li>
              <li> <b>Algorithmic Strategy and Decision Making</b>: Utilizing LLMs to improve decision-making processes and strategic planning in swarm intelligence optimization.</li>
              <li> <b>Adaptability and Dynamic Learning</b>: Investigating the role of LLMs in enhancing the adaptability and learning mechanisms of swarm intelligence algorithms in dynamic environments.</li>
              <li> <b>Scalability of Swarm Algorithms</b>: Exploring how LLMs can aid in scaling swarm intelligence algorithms for large-scale and complex problem-solving scenarios.</li>
              <li> <b>Cross-Domain Applications</b>: Discussing the application of LLM-enhanced swarm intelligence algorithms in various fields such as robotics, logistics, environmental modeling, and healthcare.</li>
              <li> <b>Model evaluation</b>: Analyzing the performance of LLM-enhanced swarm intelligence algorithms against traditional methods.</li>
              <li> <b>Integration Challenges and Solutions</b>: Addressing the technical and conceptual challenges in integrating LLMs with swarm intelligence optimization algorithms.</li>

            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2025 instruction for authors and submit your
            paper via the ICSI 2025 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS3 &quot; -- the Special Session on Research on Swarm Intelligence Optimization Algorithm Based on Large Language Model
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Ying Tan</td>
                <td>Peking University</td>
                <td>ytan@pku.edu.cn</td>
              </tr>
              <tr>
                <td>Shipeng cen</td>
                <td>Peking University</td>
                <td>censhipeng@pku.edu.cn</td>
              </tr>

            </table>
          </p>



          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br>

          <h3 id="session4">
            Special Session 4: &quot;Machine Learning and Swarm Intelligence for Combinatorial Optimization Problem&quot;{" "}
            <p align="center">&nbsp;</p>
          </h3>
          <p>
            Addressing highly complex combinatorial optimization problems with multiple objectives and various real-world constraints, which are intractable to exact methods, presents to be one of current research challenges in evolutionary computation. With the rapid development of computation power and artificial intelligence, machine learning and swarm intelligence have become promising tools. Machine learning algorithms, such as the reinforcement learning algorithms, have shown strong ability in interactive learning environment. Swarm intelligence algorithms, inspired by the behavior in self-organized groups, such as birds, ants, bacteria, etc., hold the superiority in solving complex optimization problems. How to utilize swarm intelligence algorithms and machine learning algorithms to deal with combinatorial optimization problem remains to be an interesting topic and has attracted attentions from both researchers and engineers.
            <br></br>
            <br></br>

            The objective of this special session is to gather recent theoretical contributions in machine learning and swarm intelligence fields. And it also collects unpublished methods for practical combinatorial optimization problems.


            {" "}
          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li>Theoretical contributions in machine learning algorithms: reinforcement learning, deep learning, machine learning, meta-learning, etc;</li>
              <li>Unpublished ideas in swarm intelligence algorithms: particle swarm optimization, bacterial foraging optimization, genetic algorithm, hydrological cycle optimization, grey wolf optimization, artificial fish search algorithm, etc;</li>
              <li>Efficient methods for combinatorial optimization problems such as vehicle routing problem, nurse scheduling, etc;</li>
              <li>Original work towards multi-objective problems, multi-task problems and constrained problems;</li>
              <li>Other Intelligent Computing and Swarm Intelligence Related Algorithms and Applications.</li>


            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2025 instruction for authors and submit your
            paper via the ICSI 2025 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS4 &quot; -- the Special Session on Machine Learning and Swarm Intelligence for Combinatorial Optimization Problem
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Ben Niu</td>
                <td>Shenzhen University</td>
                <td>drniuben@gmail.com</td>
              </tr>
              <tr>
                <td>Wenjie Yi</td>
                <td>Shenzhen University</td>
                <td>wenjie.yi@szu.edu.cn</td>
              </tr>

            </table>
          </p>



          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br>



          <h3 id="session5">
            Special Session 5: &quot;Biologically Inspired Intelligence for Mechatronics and Robotics&quot;{" "}
            <p align="center">&nbsp;</p>
          </h3>
          <p>
            Biologically inspired intelligence technique, an important embranchment of series on computational intelligence, plays a crucial role for robotics. The autonomous robot and vehicle industry has had an immense impact on our economy and society, and this trend will continue with biologically inspired intelligence techniques. Biologically inspired intelligence, such as biologically inspired neural networks (BINN), is about learning from nature, which can be applied to the real-world robot and vehicle systems. Recently, the research and development of bio-inspired systems for robotic applications is increasingly expanding worldwide. Biologically inspired algorithms contain emerging sub-topics such as bio-inspired neural network algorithms, brain-inspired neural networks, swam intelligence with BINN, ant colony optimization algorithms (ACO) with BINN, bee colony optimization algorithms (BCO), particle swarm optimization with BINN, immune systems with BINN, and biologically inspired evolutionary optimization and algorithms, etc. Additionally, it is decomposed of computational aspects of bio-inspired systems such as machine vision, pattern recognition for robot and vehicle systems, motion control, motion planning, movement control, sensor-motor coordination, and learning in biological systems for robot and vehicle systems.
            <br></br>
            <br></br>
            This special session seeks to highlight and present the growing interests in emerging research, development and applications in the dynamic and exciting areas of biologically inspired algorithms for mechatronics and robotics and vehicle systems (autonomous robots, unmanned underwater vehicles, and unmanned aerial vehicles).
            <br></br>
            <br></br>
            Original research papers are solicited in related areas of biologically inspired algorithms for robotics. Submissions to the Special Session should be focused on theoretical results or innovative applications of computational intelligence of biologically inspired algorithms (such as BINN) for robot and vehicle systems.
            {" "}

          </p>
          <br></br>
          <p>
            <h3>Topics of Interest</h3>
          </p>
          <p>
            Research areas include, but are not limited to, the following
            topics:
            <ul>
              <li>Evolutionary optimization, machine vision, pattern recognition for robot and vehicle systems</li>
              <li>Biologically inspired neural networks for mechatronics and robotics</li>
              <li>Deep neural networks and learning systems for robotics such as motion planning, navigation, mapping, localization, image processing, etc</li>
              <li>Bio-inspired system on computer vision and image progressing for mechatronics and robotics</li>
              <li>Human-like learning for mechatronics and robotics</li>
              <li>Theory, design, and applications of neural networks and related learning systems for mechatronics, robotics and vehicles</li>
              <li>Neuro-dynamics based models for mechatronics, robot and vehicle systems</li>
              <li>Brain-inspired neural networks for robotics, and mechatronics</li>
              <li>Swarm intelligence for mechatronics and robotics</li>
              <li>Evolutionary neuro-computing for robot and vehicle systems</li>
              <li>Bio-inspired system on machine learning, intelligent systems design for mechatronics and robotics</li>
              <li>Cellular automata for mechatronics and robotics</li>
              <li>Immune systems with BINN for mechatronics and robotics</li>
              <li>Ant colony optimization algorithms (ACO) with BINN for mechatronics and robotics</li>
              <li>Bee colony optimization algorithms (BCO) with BINN for mechatronics and robotics.</li>


            </ul>
          </p>
          <p>
            <h3>Submission</h3>
            <br></br>
            Please follow the ICSI 2025 instruction for authors and submit your
            paper via the ICSI 2025 online submission system. Please specify
            that your paper is for &nbsp;
            <strong>
              &quot;SS5 &quot; -- the Special Session on Biologically Inspired Intelligence for Mechatronics and Robotics
            </strong>{" "}
            in your paper.
          </p>
          <p>
            <h3>Organizers</h3>
            <br></br>
            <table>
              <tr>
                <td>Name</td>
                <td>Affiliate</td>
                <td>Email</td>
              </tr>
              <tr>
                <td>Tingjun Lei</td>
                <td>Mississippi State University</td>
                <td>tl1320@msstate.edu</td>
              </tr>
              <tr>
                <td>Dr. Chaomin Luo</td>
                <td>Mississippi State University</td>
                <td>Chaomin.Luo@ece.msstate.edu</td>
              </tr>

              <tr>
                <td>Dr. Zhuming Bi</td>
                <td>University Fort Wayne, Fort Wayne</td>
                <td>biz@pfw.edu</td>
              </tr>

            </table>
          </p>



          <p align="center">&nbsp;</p>
          <hr></hr>

          <p align="center">&nbsp;</p>
          <br></br> */}









          <div className="call-sp">
            <h2>ICSI 2025 Call for Special Session Proposals</h2>
            <br></br>
            <p align="justify">
              ICSI 2025 technical program will include special sessions. Their aim
              is to provide a complementary flavor to the regular sessions and
              should include hot topics of interest to the swarm intelligence
              community that may also go beyond disciplines traditionally
              represented at ICSI.
            </p>
            <p align="justify">
              <b>
                Prospective organizers of special sessions should submit proposals indicating:
              </b>
            </p>
            <p align="left">
              <ul>
                <li>
                  Title of the session.
                </li>
                <li>
                  Rationale of the need for the special session at ICSI.
                  <br></br>
                  The rationale should stress the novelty of the topic and/or its multidisciplinary flavor, and must explain how it is different  from the subjects covered by the regular sessions.
                </li>
                <li>
                  Short biography of the organizers.
                </li>
                <li>
                  List of 5 – 6 contributed papers (including titles, authors,
                  contact information of the corresponding author){" "}
                  (this can also be provided later when they become available).
                </li>
              </ul>

              <br />
            </p>

            <p>
              <b>
                <a href="./files/ICSI2025_Special_Session_Proposals_Template.docx" download="ICSI2025_Special_Session_Proposals_Template.docx">Click here to download the ICSI&apos;2025 Special Session proposals template.</a>
              </b>
            </p>
            <p align="justify">
              Proposals are due on or before 	February 21st, 2025 and should be sent
              via e-mail (in either pdf or plain ASCII text form) to the special
              sessions chair (to be announced) and forward to ICSI 2025
              secretariat at
              <a href="mailto:icsi2025@iasei.org">icsi2025@iasei.org</a>.
            </p>
            <p align="justify">
              Proposals will be evaluated based on the timeliness of the topic,
              the qualifications of the organizers and the authors of the papers
              proposed in the session. In its decision, the committee will try to
              realize a balance of the topics across the technical areas
              represented in swarm intelligence.
            </p>
            {/* <p align="justify">
              Notification of acceptance will be sent to the organizers no later
              than January 31, 2025. Authors of papers included in approved
              special sessions should submit their manuscript on or before January
              30, 2025. Manuscripts should conform to the formatting and
              electronic submission guidelines of regular ICSI papers (Springer’s
              LNCS format).
            </p> */}
            <p>
              When they submit papers, there is a choice to indicate that their
              papers are special session papers which will also undergo peer
              review. It is the responsibility of the organizers to ensure that
              their special session meets the ICSI quality standards. If, at the
              end of the review process, less than four papers are accepted, the
              session will be canceled and the accepted papers will be moved to
              regular sessions.
            </p>
          </div>

          <br /><br />
          <hr></hr>
          <br /><br />





        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default SpecialSession;
